import React from 'react';
import { useSearchParams } from 'react-router-dom';
import { BackHeader } from '../../components/BackHeader';
import { Shield } from 'lucide-react';

export const SafetyForm: React.FC = () => {
  const [searchParams] = useSearchParams();
  const formType = searchParams.get('type') || 'pre-job';
  
  const formTitles: Record<string, { title: string; subtitle: string }> = {
    'pre-job': { title: 'Pre-Job Safety Meeting', subtitle: 'Daily safety briefing' },
    'hazard': { title: 'Hazard Assessment', subtitle: 'Identify workplace hazards' },
    'incident': { title: 'Incident Report', subtitle: 'Report safety incidents' },
    'inspection': { title: 'Equipment Inspection', subtitle: 'Safety equipment check' },
  };

  const currentForm = formTitles[formType] || formTitles['pre-job'];

  return (
    <div className="min-h-full bg-fieldiq-dark">
      <BackHeader
        to="/safety"
        label="Safety"
        title={currentForm.title}
        subtitle={currentForm.subtitle}
      />
      
      <main className="max-w-[1920px] mx-auto px-4 py-4 pb-[var(--bottom-chrome)]">
        <div className="flex items-center gap-2 mb-4">
          <div className="flex-1 h-2 bg-fieldiq-border rounded-full overflow-hidden">
            <div className="w-1/3 h-full bg-fieldiq-accent-signal rounded-full" />
          </div>
          <span className="text-sm text-fieldiq-text">Step 1 of 3</span>
        </div>

        <div className="bg-fieldiq-card rounded-lg border border-fieldiq-border p-4">
          <div className="flex items-center gap-3 mb-4 text-fieldiq-accent">
            <Shield className="w-6 h-6" />
            <span className="font-semibold">Safety Checklist</span>
          </div>
          
          <div className="space-y-4">
            <label className="flex items-start gap-3 p-3 border border-fieldiq-border rounded-lg hover:bg-fieldiq-dark cursor-pointer">
              <input type="checkbox" className="mt-1 w-4 h-4 text-fieldiq-accent rounded border-fieldiq-border bg-fieldiq-dark focus:ring-fieldiq-accent" />
              <div>
                <span className="font-medium block text-white">PPE Inspection</span>
                <span className="text-sm text-fieldiq-text">All personal protective equipment checked</span>
              </div>
            </label>
            
            <label className="flex items-start gap-3 p-3 border border-fieldiq-border rounded-lg hover:bg-fieldiq-dark cursor-pointer">
              <input type="checkbox" className="mt-1 w-4 h-4 text-fieldiq-accent rounded border-fieldiq-border bg-fieldiq-dark focus:ring-fieldiq-accent" />
              <div>
                <span className="font-medium block text-white">Site Hazards</span>
                <span className="text-sm text-fieldiq-text">Worksite hazards identified and marked</span>
              </div>
            </label>
            
            <label className="flex items-start gap-3 p-3 border border-fieldiq-border rounded-lg hover:bg-fieldiq-dark cursor-pointer">
              <input type="checkbox" className="mt-1 w-4 h-4 text-fieldiq-accent rounded border-fieldiq-border bg-fieldiq-dark focus:ring-fieldiq-accent" />
              <div>
                <span className="font-medium block text-white">Emergency Procedures</span>
                <span className="text-sm text-fieldiq-text">Emergency exits and procedures reviewed</span>
              </div>
            </label>
          </div>
        </div>
      </main>
    </div>
  );
};
